import { createAction } from "@reduxjs/toolkit";

export const apiRequestStarted = createAction("api/requestStarted");
export const apiRequestSuccess = createAction("api/requestSuccess");
export const apiRequestFailed = createAction("api/requestFailed");
